<template>
  <div class="set-project">
    <Steps :current="stepCurrent">
      <template v-for="step in steps">
        <Step
          :title="step.title"
          :content="step.content"
          :key="step.title"
        ></Step>
      </template>
    </Steps>
    <div
      class="step-form"
      v-show="stepCurrent===0"
    >
      <Form
        ref="cgrForm"
        :model="xmlObj.cgrinfo"
        :label-width="90"
        inline
        :rules="cgrInfoValid"
      >
        <FormItem
          label="采购人名称"
          prop="cgrname"
          style="width: 500px;"
        >
          <Input
            :disabled="disabled"
            v-model="xmlObj.cgrinfo.cgrname"
            readonly
            type="text"
            style="width:250px;margin-right:5px;"
          ></Input>
          <Button
            :disabled="disabled"
            size="small"
            type="primary"
            @click="selectCgrVisible=true"
          >选择采购人</Button>
        </FormItem>
        <div>
          <FormItem label="采购人属性">
            <Input
              :disabled="disabled"
              v-model="xmlObj.cgrinfo.cgrtype"
              type="text"
            ></Input>
          </FormItem>
          <FormItem label="联系地址" :prop="disabled?'':'address'">
            <Input
              :disabled="disabled"
              v-model="xmlObj.cgrinfo.address"
              readonly
              type="text"
              style="width:300px;"
            ></Input>
          </FormItem>
        </div>
        <FormItem label="客户所属行业">
          <Input
            :disabled="disabled"
            v-model="xmlObj.cgrinfo.industry"
            type="text"
          ></Input>
        </FormItem>
        <FormItem label="归属团队">
          <Input
            :disabled="disabled"
            v-model="cgrInfo.filiale"
            readonly
            type="text"
            style="width:100px"
          ></Input>
        </FormItem>
        <FormItem label="客户人员">
          <Input
            readonly
            v-model="cgrInfo.accountAssistant"
            type="text"
            style="width:100px;"
          ></Input>
        </FormItem>
        <div>
          <FormItem
            label="采购联系人"
            prop="contact"
          >
            <Select
              :disabled="disabled"
              v-model="xmlObj.cgrinfo.contact"
              style="width: 120px;"
              @on-change="changeContact"
            >
              <Option
                v-for="(contact,index) in extraInfo.contactArr"
                :key="index"
                :value="contact['联系人']"
              >{{contact['联系人']}}</Option>
            </Select>
          </FormItem>
          <FormItem
            label="联系方式"
            prop="telephone"
            style="width:450px;"
          >
            <Input
              :disabled="disabled"
              type="text"
              readonly
              v-model="xmlObj.cgrinfo.telephone"
              style="width:200px;margin-right:10px;"
            ></Input>
            <Button
              :disabled="!xmlObj.cgrinfo.cgrid || disabled"
              type="primary"
              size="small"
              @click="contactVisible=true"
              v-if="editAble"
            >添加/编辑联系人</Button>
          </FormItem>
        </div>
        <FormItem label="是否集团客户">
          <Select
            :disabled="disabled"
            v-model="xmlObj.cgrinfo.iscustomer"
            style="width:80px"
            @on-change="customerChange"
          >
            <Option value="是">是</Option>
            <Option value="否">否</Option>
          </Select>
        </FormItem>
        <FormItem label="客户来源"
          prop="customerSource"
        >
          <Select
            :disabled="disabled"
            v-model="xmlObj.cgrinfo.customerSource"
            style="width:120px"
            @on-change="customerChange"
          >
            <Option
              v-for="item in customOrigin"
              :value="item.itemName"
              :key="item.key"
            >{{ item.itemName }}</Option>
          </Select>
        </FormItem>
        <div v-if="xmlObj.cgrinfo.iscustomer==='是'">
          <FormItem label="集团客户">
            <Select
              :disabled="disabled"
              v-model="xmlObj.cgrinfo.customername"
              @on-change="branchChange"
              style="width:250px;"
            >
              <Option
                v-for="customer in extraInfo.customerArr"
                :key="customer.id"
                :value="customer.fullName"
              >{{customer.fullName}}</Option>
            </Select>
          </FormItem>
          <FormItem label="分支机构">
            <Select
              :disabled="disabled"
              v-model="xmlObj.cgrinfo.branch"
              style="width:300px;"
            >
              <Option
                v-for="branch in extraInfo.branchArr"
                :key="branch.id"
                :value="branch.fullName"
              >{{branch.fullName}}</Option>
            </Select>
          </FormItem>
        </div>
      </Form>
      <div class="step-btn">
        <Button
          v-if="disabled"
          type="error"
          @click="preEdit"
          style="margin-right: 10px;"
          v-show="finishEditDisabled == false"
        >退回</Button>
        <Button
          :disabled="disabled"
          type="success"
          style="margin-right: 10px;"
          @click="saveXml(0)"
        >暂存</Button>
        <Button
          type="success"
          @click="nextStep"
        >下一步</Button>
      </div>
    </div>
    <div
      class="step-form"
      v-show="stepCurrent===1"
    >
      <Form
        ref="categoryForm"
        :model="xmlObj.category"
        :rules="categoryValid"
        :label-width="80"
        inline
      >
        <FormItem
          label="业务范围"
          prop="business"
        >
          <Select
            :disabled="disabled"
            style="width:120px;"
            v-model="xmlObj.category.business"
            @on-change="businessChange"
          >
            <Option
              v-for="business in extraInfo.businessScope"
              :value="business.itemName"
              :key="business.itemName"
            >{{business.itemName}}</Option>
          </Select>
        </FormItem>
        <FormItem
          label="项目性质"
          prop="projectnature"
        >
          <Select
            :disabled="disabled"
            style="width: 150px"
            v-model="xmlObj.category.projectnature"
            @on-change="natureChange"
          >
            <Option
              v-for="projectnature in extraInfo.projectnatureArr"
              :value="projectnature['itemName']"
              :key="projectnature['itemName']"
            >{{projectnature['itemName']}}</Option>
          </Select>
        </FormItem>
        <!-- <FormItem label="招标平台">
          <Input
            :disabled="disabled"
            v-model="xmlObj.category.platform"
            type="text"
            readonly
          ></Input>
        </FormItem> -->
        <FormItem
          label="资金来源"
          prop="fundsprovid"
        >
          <Select
            :disabled="disabled"
            style="width:130px;"
            v-model="xmlObj.category.fundsprovid"
            @on-change="fundChange"
            @on-open-change="resetCgType"
          >
            <Option
              v-for="fundsprovid in extraInfo.fundsprovidArr"
              :value="fundsprovid.itemName"
              :key="fundsprovid.itemName"
            >{{fundsprovid.itemName}}</Option>
          </Select>
        </FormItem>
        <FormItem
          label="采购方式"
          prop="cgmethod"
          v-if="!ifConsult"
        >
          <Select
            :disabled="disabled"
            style="width:120px;"
            v-model="xmlObj.category.cgmethod"
          >
            <Option
              v-for="cgmethod in extraInfo.cgmethodArr"
              :value="cgmethod.itemName"
              :key="cgmethod.itemName"
            >{{cgmethod.itemName}}</Option>
          </Select>
        </FormItem>
        <FormItem
          label="采购类别"
          prop="cgtype"
        >
          <Select
            :disabled="disabled"
            style="width:120px;"
            v-model="xmlObj.category.cgtype"
          >
            <Option
              v-for="cgtype in extraInfo.cgtypes"
              :value="cgtype.itemName"
              :key="cgtype.itemName"
            >{{cgtype.itemName}}</Option>
          </Select>
        </FormItem>
        <FormItem label="是否采购进口产品" :label-width="120" prop="importproduct" v-if="!hideImport">
          <Select
            :disabled="disabled"
            style="width:150px;"
            v-model="xmlObj.category.importproduct"
          >
            <Option value="是">是</Option>
            <Option value="否">否</Option>
          </Select>
        </FormItem>
        <FormItem label="是否有论证" v-if="!ifConsult">
          <Select
            :disabled="disabled"
            style="width:120px;"
            v-model="xmlObj.category.argument"
          >
            <Option value="是">是</Option>
            <Option value="否">否</Option>
          </Select>
        </FormItem>
        
        <FormItem
          label="包组数量"
          prop="package"
        >
          <Input
            :disabled="disabled"
            type="text"
            style="width:100px;"
            v-model="xmlObj.category.package"
          ></Input>
        </FormItem>
        <FormItem label="评定分离" v-if="!ifConsult">
          <Select
            :disabled="disabled"
            style="width:100px;"
            v-model="xmlObj.category.separation"
          >
            <Option value="是">是</Option>
            <Option value="否">否</Option>
          </Select>
        </FormItem>
        <FormItem label="财委派单" v-if="!ifConsult">
          <Select
            :disabled="disabled"
            style="width:100px;"
            v-model="xmlObj.category.finance"
          >
            <Option value="是">是</Option>
            <Option value="否">否</Option>
          </Select>
        </FormItem>
        <FormItem
          :label="ifConsult?'咨询内容':'采购内容'"
          prop="cgcontent"
        >
          <Input
            :disabled="disabled"
            type="text"
            style="width: 500px;"
            v-model="xmlObj.category.cgcontent"
          ></Input>
        </FormItem>
      </Form>
      <Form
        ref="proForm"
        :model="xmlObj.baseinfo"
        :label-width="80"
        inline
        :rules="baseInfoValid"
      >
        <FormItem
          label="项目名称"
          prop="projectname"
        >
          <Input
            :disabled="disabled"
            v-model="xmlObj.baseinfo.projectname"
            type="text"
            style="width:308px"
          ></Input>
        </FormItem>
        <!-- <FormItem
          label="客户归属(原部门)"
          :labelWidth="120"
        >
          <Input
            :disabled="true"
            v-model="xmlObj.baseinfo.apartment"
            style="width:110px"
          ></Input>
        </FormItem> -->
        <FormItem
          label="客户归属(原部门)"
          :label-width="120"
          prop="apartment"
        >
          <Select
            :disabled="disabled"
            v-model="xmlObj.baseinfo.apartment"
            style="width: 120px;"
            @on-change="getArea"
          >
            <Option
              v-for="depart in extraInfo.departArr"
              :key="depart['id']"
              :value="depart['name']"
            >{{depart['name']}}</Option>
          </Select>
        </FormItem>
        <FormItem
          label="中心"
          v-if="xmlObj.baseinfo.apartment==='北京'||xmlObj.baseinfo.apartment==='军工事业部'"
          :label-width="60"
          prop="center"
        >
          <Select
            :disabled="disabled"
            v-model="xmlObj.baseinfo.center"
            style="width:100px"
          >
            <Option
              v-for="item in ['北方中心', '南方中心']"
              :key="item"
              :value="item"
            >{{item}}</Option>
          </Select>
        </FormItem>
        <FormItem
          label="收入归属"
          prop="childcompany"
        >
          <Select
            :disabled="disabled"
            v-model="xmlObj.baseinfo.childcompany"
            style="width: 300px;"
          >
            <Option
              v-for="company in extraInfo.childCompanies"
              :key="company.id"
              :value="company.cName"
            >{{company.cName}}</Option>
          </Select>
          <!-- <div style="color:#ed4014">注意必选，下周将限制必填（流转中的项目请尽快确认）</div> -->
        </FormItem>
        <FormItem
          label="项目所属地"
          prop="area"
          :labelWidth="94"
        >
          <Cascader
            :data="addressArr"
            v-model="projectArea"
            :disabled="disabled"
            style="width:150px"
            placeholder="请选择省/市"
            @on-change="areaChange"
          >
          </Cascader>
        </FormItem>
        <!-- <FormItem
          label="地区"
          prop="area"
        >
          <Select
            :disabled="disabled"
            v-model="xmlObj.baseinfo.area"
            style="width: 100px;"
            v-if="extraInfo.areaArr.length>0"
          >
            <Option
              v-for="area in extraInfo.areaArr"
              :key="area.id"
              :value="area.itemName"
            >{{area.itemName}}</Option>
          </Select>
          <Input
            :disabled="disabled"
            v-model="xmlObj.baseinfo.area"
            style="width: 100px;"
            v-else
          ></Input>
        </FormItem> -->
        <FormItem
          label="项目简称"
          required
        >
          <Input
            :disabled="disabled"
            type="text"
            readonly
            placeholder="请点击最右侧生成按钮"
            v-model="xmlObj.baseinfo.projectabbr"
            style="width:120px"
          ></Input>
        </FormItem>
        <FormItem
          label="项目编号全称"
          :label-width="105"
          required
        >
          <Input
            :disabled="disabled"
            type="text"
            v-model="xmlObj.baseinfo.projectnumfull"
            readonly
            placeholder="请点击右侧生成按钮"
            style="width:150px;margin-right:10px;"
          ></Input>
          <Button
            type="primary"
            size="small"
            :disabled="disabled"
            @click="buildWorkNum"
          >{{ xmlObj.baseinfo.projectnumfull =='' ? '生成' : '重新生成' }}</Button>
          <Checkbox style="margin-left:10px" @on-change="localChange">
            采购人（交易中心）项目编号
          </Checkbox>
        </FormItem>
        <FormItem label="采购人（交易中心）项目编号" :labelWidth="180" v-if="showLocalnum">
          <Input
            :disabled="disabled"
            v-model="xmlObj.baseinfo.localnum"
            type="text"
          ></Input>
        </FormItem>
        <FormItem
          label="客户经理"
          prop="manager"
          style="width: 340px;"
        >
          <Input
            :disabled="disabled"
            v-model="xmlObj.baseinfo.manager"
            readonly
            type="text"
            style="width: 150px;margin-right:10px;"
          ></Input>
          <Button
            :disabled="disabled"
            type="primary"
            size="small"
            @click="addManagerVisible=!addManagerVisible"
          >添加/修改</Button>
        </FormItem>
        <FormItem
          label="客户经理（编辑）"
          style="width: 400px;"
          v-if="addManagerVisible"
          :labelWidth="120"
        >
          <Input
            :disabled="disabled"
            v-model="extraInfo.addManager"
            type="text"
            style="width: 150px;margin-right:10px;"
          ></Input>
          <Button
            type="primary"
            size="small"
            @click="reviseManager"
            style="margin-right:5px;"
          >覆盖</Button>
          <Button
            type="primary"
            size="small"
            @click="addManager"
          >添加</Button>
        </FormItem>
        <FormItem
          label="客户需求"
          prop="customerFileName"
        >
          <Input
            v-model="xmlObj.baseinfo.customerFileName"
            style="width:300px;margin-right:10px;"
            readonly
            :disabled="disabled"
          ></Input>
          <Button
            type="primary"
            size="small"
            :disabled="disabled"
            @click="customerFileSelect"
            style="margin-right:5px;"
          >上传</Button>
          <Button
            type="primary"
            size="small"
            @click="downloadCustomerFile"
          >下载</Button>
          <input
            type="file"
            ref="customerFile"
            style="display:none"
            @change="customerFileUpload"
          >
          <span style="color:#ed4014">（请注意上传客户需求文件）</span>
        </FormItem>
      </Form>
      <div class="step-btn">
        <Button
          v-if="disabled"
          type="error"
          @click="preEdit"
          style="margin-right: 10px;"
          v-show="finishEditDisabled == false"
        >退回</Button>
        <Button
          :disabled="disabled"
          type="success"
          style="margin-right: 10px;"
          @click="saveXml(0)"
        >暂存</Button>
        <Button
          type="success"
          @click="preStep"
          style="margin-right: 10px;"
        >上一步</Button>
        <Button
          type="success"
          @click="nextStep"
        >下一步</Button>
      </div>
    </div>
    
    <div
      class="step-form"
      v-show="stepCurrent===2"
    >
      <Form
        ref="budgetForm"
        :model="xmlObj.budget"
        :rules="budgetValid"
        :label-width="90"
        inline
      >
        <FormItem
          label="是否资格标"
          prop="eligibility"
        >
          <!-- <Input
            :disabled="disabled"
            type="text"
            v-model="xmlObj.budget.eligibility"
          ></Input> -->
          <Select
            :disabled="disabled"
            style="width:120px"
            v-model="xmlObj.budget.eligibility"
          >
            <Option :value="1">是</Option>
            <Option :value="0">否</Option>
          </Select>
        </FormItem>
        <FormItem
          label="预算金额(元)"
          :label-width="100"
          prop="budgetamount"
        >
          <Input
            :disabled="disabled"
            type="text"
            v-model="xmlObj.budget.budgetamount"
          ></Input>
        </FormItem>
        <FormItem
          label="服务费类型"
          style="width:300px;"
          prop="servicetype"
        >
          <Input
            :disabled="disabled"
            type="text"
            v-model="xmlObj.budget.servicetype"
            readonly
            placeholder="请点击右侧选择按钮"
            style="width:150px;margin-right:10px;"
          ></Input>
          <Button
            size="small"
            type="primary"
            :disabled="xmlObj.budget.budgetamount==='' || disabled"
            @click="chooseServiceFee"
          >选择</Button>
        </FormItem>
        <FormItem label="居间服务费" :label-width="90" prop="intermediary">
          <Select
            :disabled="disabled"
            style="width:120px;"
            v-model="xmlObj.budget.intermediary"
          >
            <Option value="是">是</Option>
            <Option value="否">否</Option>
          </Select>
        </FormItem>
        <FormItem label="预计服务费">
          <Input
            :disabled="disabled"
            type="text"
            v-model="xmlObj.budget.expectcharge"
            readonly
          ></Input>
        </FormItem>
        <FormItem label="收费对象" :label-width="90" prop="chargingObjects" v-if="ifConsult">
          <Select
            :disabled="disabled"
            style="width:120px;"
            v-model="xmlObj.budget.chargingObjects"
          >
            <Option value="采购人">采购人</Option>
            <Option value="供应商">供应商</Option>
          </Select>
        </FormItem>
        <FormItem label="备注信息">
          <Input
            v-model="xmlObj.baseinfo.comment"
            :disabled="disabled"
            style="width:380px"
          ></Input>
        </FormItem>
        <FormItem
          label="委托协议"
          prop="proxyFileName"
        >
          <Input
            v-model="xmlObj.baseinfo.proxyFileName"
            style="width:350px;margin-right:10px;"
            readonly
            :disabled="disabled"
          ></Input>
          <Button
            type="primary"
            size="small"
            :disabled="disabled"
            @click="proxyFileSelect"
            style="margin-right:5px"
          >上传</Button>
          <Button
            type="primary"
            size="small"
            @click="downloadProxyFile"
            style="margin-right:5px"
          >下载</Button>
          <Button
            size="small"
            type="success"
            @click="preventClick('fill')"
            style="margin-right:5px"
            :disabled="disabled"
          >委托协议参数填写</Button>
          <Button
            size="small"
            type="success"
            @click="preventClick('download')"
            :disabled="disabled"
          >标准委托协议下载</Button>
          <input
            type="file"
            ref="proxyFile"
            style="display:none"
            @change="proxyFileUpload"
          >
          <div style="color:#ed4014">（请注意上传委托协议文件）</div>
        </FormItem>
      </Form>
      <div class="step-btn">
        <Button
          v-if="disabled"
          type="error"
          @click="preEdit"
          style="margin-right: 10px;"
          v-show="finishEditDisabled == false"
        >退回</Button>
        <Button
          :disabled="disabled"
          type="success"
          style="margin-right: 10px;"
          @click="saveXml(0)"
        >暂存</Button>
        <Button
          type="success"
          @click="preStep"
          style="margin-right: 10px;"
        >上一步</Button>
        <Button
          type="success"
          @click="finishEdit"
          v-show="finishEditDisabled == false"
        >发起/转交</Button>
        <!-- <Button @click="specialEndFlow">特殊创建项目</Button> -->
      </div>
    </div>
    <!-- 采购人modal -->
    <Modal
      v-model="selectCgrVisible"
      width="800px"
      :transfer="false"
    >
      <div slot="header">
        采购人选择
      </div>
      <select-cgr @selected="selectedCgr"></select-cgr>
      <div slot="footer">
        <Button @click="selectCgrVisible=false">取消</Button>
        <!-- <Button type="primary">确定</Button> -->
      </div>
    </Modal>
    <edit-contact
      :cgrid="xmlObj.cgrinfo.cgrid"
      :contactVisible="contactVisible"
      @cancel="contactVisible=false"
      :originContactArr="extraInfo.contactArr"
      @finish="finishEditContact"
    ></edit-contact>
    <Modal
      v-model="serviceFeeVisible"
      title="服务费类型"
      :transfer="false"
    >
      <serviceFee
        :serviceData="serviceData"
        ref="service"
      ></serviceFee>
      <div slot="footer">
        <Button @click="serviceFeeVisible=false">取消</Button>
        <Button @click="confirmServiceFee">确定</Button>
      </div>
    </Modal>
    <!-- 项目重招 -->
    <Modal
      v-model="againProjectVisible"
      title="项目重招"
      width="750"
      :transfer="false"
      :closable="false"
      :mask-closable="false"
    >
      <agProjectSelect
        @importProject="importProject"
        :visibleChange="againProjectVisible"
      ></agProjectSelect>
      <div slot="footer">
        <Button
          type="error"
          @click="cancelAgainProject"
        >取消</Button>
      </div>
    </Modal>
    <!-- 委托协议 -->
    <Modal
      class="proxy-modal"
      v-model="proxyVisible"
      title="委托协议"
      :transfer="false"
      :mask-closable="false"
      width="1000"
    >
      <iframe
        :src="proxyUrl"
        style="width:100%;height:600px;"
        v-if="commissionFileType == 'download'"
      ></iframe>
      <agreement 
        :projectData="projectData" 
        ref="agreement" 
        :argumentData="argumentData" 
        @visible="proxyVisible = false"
        :commissionType="commissionType"
        v-else>
      </agreement>
      <div slot="footer">
        <Button @click="save" type="primary"  v-if="commissionFileType !== 'download'">保存</Button>
      </div>
    </Modal>
    <Modal title="委托协议版本选择" v-model="commissionModalChoose" :transfer="false">
      <RadioGroup v-model="commissionType">
        <div v-show="commissionFileType == 'download'">
          <span>固定版本：</span>
          <Radio label="staticStandard">标准版本</Radio>
          <Radio label="staticArmyYear">军队非涉密（年度）</Radio>
          <Radio label="staticArmySingle">军队非涉密（单项）</Radio>
        </div>
        <div style="margin-top:10px">
          <span>{{ commissionFileType == 'download' ? '可修改版本：' : '版本选择：' }}</span>
          <Radio label="standard">标准版本</Radio>
          <Radio label="armyYear">军队非涉密（年度）</Radio>
          <Radio label="armySingle">军队非涉密（单项）</Radio>
        </div>
      </RadioGroup>
      <div slot="footer">
        <Button @click="commissionModalChoose=false">取消</Button>
        <Button @click="commissionConfirm" type="primary">确定</Button>
      </div>
    </Modal>
  </div>
</template>


<script>
import axios from "axios"
import qs from "qs"
import x2js from "x2js"
import selectCgr from "./selectCgr"
import editContact from "./editContact"
import serviceFee from "./serviceFee"
import agProjectSelect from "./agProjectSelect"
import { formatDate } from '@/lib/tool'
import requestUrls from '@/lib/requestUrls'
import ajax from '@/lib/ajax'
import agreement from '@/components/agreement'
import localFile from '@/lib/localFile'
import ChineseDistricts from '@/lib/area'

export default {
  //props:['userObj','uid','proassistant','disabled','againProject'],
  props: {
    // 用户信息
    userObj: {
      type: Object,
      default: {
        phone: "",
        name: ""
      },
      required: true
    },
    // xml uId
    uid: {
      type: String
    },
    // 项目助理
    proassistant: {
      type: String
    },
    // 查看模式
    disabled: {
      default: false
    },
    finishEditDisabled: {
      default: false
    },
    // 重招
    againProject: {
      default: false
    },
    // 外部应用显示变化
    visibleChange: {
      default: false
    },
    workflow: {
      default() {
        return {}
      }
    }
  },
  components: {
    selectCgr,
    editContact,
    serviceFee,
    agProjectSelect,
    agreement
  },
  data() {
    let validNum = (rule, value, callback) => {
      if (isNaN(value) || value === "" || value === null) {
        callback(new Error("请输入数字"));
      } else {
        callback();
      }
    }
    let validNum2 = (rule, value, callback) => {
      if (isNaN(value) || value === null) {
        callback(new Error("请输入数字"));
      } else {
        callback();
      }
    }
    return {
      commissionType: '',
      commissionModalChoose: false,
      commissionFileType: '',
      stepCurrent: 0,
      proxyVisible: false,
      steps: [
        {
          title: "采购人基本资料",
          content: ""
        },
        {
          title: "项目基本资料",
          content: ""
        },
        {
          title: "预算及应收款",
          content: ""
        }
      ],
      xmlObj: {
        baseinfo: {
          apartment: "",
          area: "",
          projectabbr: "",
          projectnumfull: "",
          localnum: "",
          projectname: "",
          manager: "",
          protime: "",
          prostatus: "等待用户需求",
          proassistant: "",
          proorigin: "内网立项",
          customerFileName: '',
          customerFileId: '',
          proxyFileName: '',
          proxyFileId: '',
          childcompany: '',
          comment: '',
          center: ''
        },
        category: {
          business: "",
          platform: "",
          projectnature: "",
          cgtype: "",
          fundsprovid: "",
          cgmethod: "",
          importproduct: "",
          argument: "",
          package: '',
          cgcontent: "",
          separation: "",
          finance: ""
        },
        cgrinfo: {
          customername: "",
          branch: "",
          cgrname: "",
          cgrid: "",
          address: "",
          telephone: "",
          contact: "",
          cgrtype: "",
          industry: "",
          iscustomer: "",
          customerSource: ""
        },
        budget: {
          eligibility: "",
          budgetamount: "",
          servicetype: "",
          servicediscount: '',
          expectcharge: "",
          // servicecharge: "",
          intermediary: "",
          chargingObjects: ''
        },
        workflow: {
          title: ""
        }
      },
      baseInfoValid: {
        apartment: [
          { required: true, message: "部门不能为空", trigger: "change" }
        ],
        area: [{ required: true, message: "地区不能为空", trigger: "change" }],
        childcompany: [{ required: true, message: "收入归属不能为空", trigger: "change" }],
        projectname: [
          { required: true, message: "项目名称不能为空", trigger: "blur" }
        ],
        manager: [
          { required: true, message: "客户经理不能为空", trigger: "blur" }
        ],
      },
      cgrInfoValid: {
        cgrname: [
          { required: true, message: "采购人不能为空", trigger: "blur" }
        ],
        address: [
          { required: true, message: "联系地址不能为空，请前往采购人档案补充完整", trigger: "change" }
        ],
        contact: [
          { required: true, message: "采购联系人不能为空", trigger: "change" }
        ],
        // filiale: [
        //   { required: true, message: "归属团队不能为空", trigger: "blur" }
        // ],
        telephone: [
          { required: true, message: "联系方式不能为空", trigger: "change" }
        ], 
        customerSource: [
          {required: true, message: "客户来源不能为空", trigger: "change"}
        ]
      },
      categoryValid: {
        business: [
          { required: true, message: "业务范围不能为空", trigger: "change" }
        ],
        projectnature: [
          { required: true, message: "项目性质不能为空", trigger: "change" }
        ],
        cgtype: [
          { required: true, message: "采购类别不能为空", trigger: "change" }
        ],
        fundsprovid: [
          { required: true, message: "资金来源不能为空", trigger: "change" }
        ],
        importproduct: [
          { required: true, message: "采购进出口不能为空", trigger: "change" }
        ],
        cgmethod: [
          { required: true, message: "采购方式不能为空", trigger: "change" }
        ],
        package: [
          { required: true, message: "包组数量不能为空", trigger: "blur" },
          { validator: validNum, trigger: "blur" }
        ]
      },
      budgetValid: {
        // eligibility: [{ validator: validNum2, trigger: "blur" }],
        budgetamount: [
          { required: true, message: "预算金额不能为空", trigger: "blur" },
          { validator: validNum, trigger: "blur" }
        ],
        servicetype: [
          { required: true, message: "服务费类型不能为空", trigger: "blur" }
        ],
        intermediary: [
          { required: true, message: "居间服务费不能为空", trigger: "blur" }
        ],
        chargingObjects: [
          { required: true, message: "收费对象不能为空", trigger: "blur" }
        ]
      },
      // 其他源数据
      extraInfo: {
        // 部门
        departArr: [],
        // 地区
        areaArr: [],
        // 收入归属
        childCompanies: [],
        // 经理
        addManager: "",
        // 联系人
        contactArr: [],
        // 集团客户
        customerArr: [],
        // 集团客户分支
        branchArr: [],
        // 业务范围
        businessScope: [],
        // 项目性质
        projectnatureArr: [],
        // 采购类别
        cgtypes: [],
        // 资金来源
        fundsprovidArr: [],
        // 采购方式
        cgmethodArr: []
      },
      addManagerVisible: false,
      selectCgrVisible: false,
      contactVisible: false,
      serviceFeeVisible: false,
      serviceData: {},
      newUid: "",
      againProjectVisible: false,
      proxyUrl: '',
      currentObj: {},
      projectData: {},
      argumentData: {},
      cgrInfo: {},
      addressArr: [],
      projectArea: [],
      showLocalnum: false,
      customOrigin: []
    };
  },
  computed: {
    editAble () {
      return this.cgrInfo.accountAssistant === this.userObj.name
    },
    hideImport () {
      return this.xmlObj.category.projectnature === '部队(涉密)' || this.xmlObj.category.projectnature === '部队(非涉密)' || this.xmlObj.category.projectnature === '军工(涉密)' || this.xmlObj.category.projectnature === '军工(非涉密)'
    },
    ifConsult () {
      return this.xmlObj.category.business === '采购咨询'
    }
  },
  async mounted() {
    this.getAllDepart()
    // 集团客户数据
    if (this.extraInfo.customerArr.length === 0) {
      // 获取集团客户数据
      let rep = await ajax.get('/api/services/app/BaseEntity/GetSpecialCliens')
      this.extraInfo.customerArr = rep.data.result.items
    }
  },
  methods: {
    async init () {
      this.customOrigin = await this.getDataDict('客户来源')
      if (!this.xmlObj.cgrinfo.cgrname) return
      // 获取采购人归属
      ajax('/api/services/app/ClPurchase/GetPaged',{
        params: {
          filter: `purchase == "${this.xmlObj.cgrinfo.cgrname}"`
        }
      }).then(res =>{
        this.cgrInfo = res.data.result.items[0]
        // this.xmlObj.baseinfo.apartment = res.data.result.items[0].filiale
        // 获取收入归属
        this.getArea(this.xmlObj.baseinfo.apartment)
      })
      // 获取资金来源
      if (this.extraInfo.fundsprovidArr.length === 0) {
        // 业务范围
        this.extraInfo.businessScope = await this.getDataDict('业务范围(军工)', 1)
      }
      // 采购方式
      if (this.extraInfo.cgmethodArr.length === 0) {
        this.extraInfo.cgmethodArr = await this.getDataDict('采购方式')
      }
      // 项目性质
      if (this.xmlObj.category.business) {
        let projectnature = this.xmlObj.category.projectnature;
        await this.businessChange(this.xmlObj.category.business);
        for (let i = 0; i < this.extraInfo.projectnatureArr.length; i++) {
          let nature = this.extraInfo.projectnatureArr[i];
          if (nature["itemName"] === projectnature) {
            this.xmlObj.category.projectnature = projectnature;
            break;
          }
        }
      }
      this.fundChange(this.xmlObj.category.fundsprovid)
      if (this.hideImport) {
        this.extraInfo.fundsprovidArr = await this.getDataDict('资金类型(军工)')
      } else {
        this.extraInfo.fundsprovidArr = await this.getDataDict('资金类型')
      }
      // 省市
      this.addressArr = ChineseDistricts['86'].map(item => {
        return {  // 省
          id: item.code,
          value: item.address,
          label: item.address,
          children: Object.values(ChineseDistricts[item.code]).map((city, index) => {
            let code = Object.keys(ChineseDistricts[item.code])[index]
            return {  // 市
              id: code,
              value: city,
              label: city
            }
          })
        }
      })
    },
    customerFileSelect() {
      this.$refs.customerFile.click()
    },
    proxyFileSelect() {
      this.$refs.proxyFile.click()
    },
    async getChildCompanies(district) {
      let rep = await ajax.get(requestUrls.bankAccount.getAll, {
        params: {
          filter: `district == "${district}"`
        }
      })
      this.extraInfo.childCompanies = []
      if (rep.data.success && rep.data.result.items.length > 0) {
        let childcompany = this.xmlObj.baseinfo.childcompany
        this.xmlObj.baseinfo.childcompany = ''
        // 去除重复收入归属
        let hadPut = []
        rep.data.result.items.forEach(item => {
          if (hadPut.indexOf(item.cName) === -1) {
            hadPut.push(item.cName)
            this.extraInfo.childCompanies.push(item)
            if (item.cName === childcompany) {
              this.xmlObj.baseinfo.childcompany = childcompany
            }
          }
        })
      }
    },
    async customerFileUpload() {
      if (this.$refs.customerFile.files.length === 0) {
        return
      }
      this.$Spin.show()
      try {
        // let formData = new FormData()
        // formData.append('fileToUpload', this.$refs.customerFile.files[0])
        // formData.append('username', this.userObj.name)
        // let rep = await axios.post('http://oa.chinapsp.cn:8088/FileModule/Gdfile/AbpUpload', formData)
        // 上传文件
        let fileRep = await localFile.uploadFile(this.$refs.customerFile.files[0])

        if (!fileRep) {
          throw 'uploadError'
        }

        this.$Spin.hide()
        // 清空数据以监听上传change事件
        this.$refs.customerFile.value = ''

        this.xmlObj.baseinfo.customerFileId = fileRep.serviceGuid
        this.xmlObj.baseinfo.customerFileName = fileRep.fileName
        this.$Message.success('上传成功')

      } catch (err) {
        this.$refs.customerFile.value = ''
        this.$Spin.hide()
        this.$refs.customerFile.files = []
        this.$Message.error('上传失败')
      }
    },
    // 这里要优化复用
    async proxyFileUpload() {
      if (this.$refs.proxyFile.files.length === 0) {
        return
      }
      this.$Spin.show()
      try {
        // let formData = new FormData()
        // formData.append('fileToUpload', this.$refs.proxyFile.files[0])
        // formData.append('username', this.userObj.name)
        // let rep = await axios.post('http://oa.chinapsp.cn:8088/FileModule/Gdfile/AbpUpload', formData)

        let fileRep = await localFile.uploadFile(this.$refs.proxyFile.files[0])

        if (!fileRep) {
          throw 'uploadError'
        }

        this.$Spin.hide()
        // 清空数据以监听上传change事件
        this.$refs.proxyFile.value = ''
        
        this.xmlObj.baseinfo.proxyFileId = fileRep.serviceGuid
        this.xmlObj.baseinfo.proxyFileName = fileRep.fileName
        this.$Message.success('上传成功')

      } catch (err) {
        this.$refs.proxyFile.value = ''
        this.$Spin.hide()
        this.$refs.proxyFile.files = []
        this.$Message.error('上传失败')
      }
    },
    async nextStep() {
      // 数据校验
      let isValid = true;
      if (this.stepCurrent === 0) {
        if (!this.cgrInfo.filiale) {
          this.$Message.error('请前往采购人档案补充采购人归属团队信息！')
          return
        }
        this.$refs.cgrForm.validate(async (valid) => {
          if (!valid) {
            isValid = false
          }
        });
      }
      if (this.stepCurrent === 1) {
        // 财政性资金判断
        if (!this.extraInfo.fundsprovidArr.some(item => item.itemName === this.xmlObj.category.fundsprovid)) {
          this.$Message.info('请重新选择资金来源！')
          return
        }
        if (this.showLocalnum && !this.xmlObj.baseinfo.localnum) {
          this.$Message.info('请输入采购人（交易中心）项目编号！')
          return
        }
        this.$refs.proForm.validate(valid => {
          if (!valid) {
            isValid = false;
          } else {
            this.$refs.categoryForm.validate(valid => {
              if (!valid) {
                isValid = false;
              } else {
                if (!this.xmlObj.category.projectnature) {
                  this.$Message.info('操作过快，项目性质未加载，请返回上一步')
                  isValid = false;
                }
                // 检查项目简称、项目编号（xmlObj归类不同，不能直接使用valid）
                if (
                  this.xmlObj.baseinfo.projectnumfull === "" ||
                  this.xmlObj.baseinfo.projectabbr === ""
                ) {
                  this.$Message.error("项目编号不能为空");
                  isValid = false;
                }
              }
            });
          }
        });
      }
      if (!isValid) {
        return;
      }

      // 页面跳转
      this.stepCurrent += 1;
      /**
       * 数据更新
       * 部分数据更新是为了选择
       * 部分数据更新是为了填充已有数据
       */
      if (this.uid || this.againProject) {
        // 验证（防止change校验）
        // this.$refs.proForm.validate()
        this.$refs.cgrForm.validate()
        this.$refs.categoryForm.validate()
        this.$refs.budgetForm.validate()
      }
    },
    preStep() {
      this.stepCurrent -= 1;
    },
    // 发起或转交或结束流程需要调用一次（保存数据）
    preEdit() {
      this.$emit('preEdit', true)
    },
    finishEdit() {
      // 结束编辑
      if (this.stepCurrent === 2) {
        this.$refs.budgetForm.validate(async valid => {
          if (valid) {
            let rep = await this.saveXml()
            this.$emit('finishEdit', rep) // rep:true||false
          }
        })
      } else {
        this.$Message.error('请翻至最后一页')
      }
    },
    // 结束流程的数据处理
    async endFlow() {
      if (this.proassistant) {
        this.xmlObj.baseinfo.proassistant = this.proassistant
        let time = parseInt(this.workflow.CreatedTime.slice(6, 19))
        time = formatDate(time)
        this.xmlObj.baseinfo.protime = time
        // 调用保存
        let rep = await this.saveXml(2)
        this.$emit('endFlow', rep) // rep:true||false
      }
    },
    // 特殊结束流程的数据处理
    async specialEndFlow() {
      if (this.proassistant) {
        this.xmlObj.baseinfo.proassistant = this.proassistant
        let time = parseInt(this.workflow.CreatedTime.slice(6, 19))
        time = formatDate(time)
        this.xmlObj.baseinfo.protime = time

        // 调用保存
        let rep = await this.saveXml(2)
        this.$emit('specialEndFlow', rep) // rep:true||false
      }
    },
    // 获取用户部门信息
    async getUserDepart() {
      let district = []
      if (this.$store.state.session.user.selectDistrict.length > 0) {
        district = this.$store.state.session.user.selectDistrict.split(',')
      }
      if (district.length > 0) {
        this.xmlObj.baseinfo.apartment = district[0]
        this.getArea(district[0])
      }
    },
    // 获取所有部门
    async getAllDepart() {
      let rep = await ajax.get(requestUrls.CLDistrict.GetListWithoutRole)
      this.extraInfo.departArr = []
      if (rep.data.success && rep.data.result.items.length > 0) {
        this.extraInfo.departArr = rep.data.result.items
      }
    },
    // 获取地区
    async getArea(name) {
      this.getChildCompanies(name)
      const target = this.extraInfo.departArr.filter(item => item.name === name)[0]
      if (target) this.extraInfo.areaArr = await this.getDataDict('地区属性', 0, target.id)
      if (!(name === '北京' || name === '军工事业部')) this.xmlObj.baseinfo.center = ''
    },
    reviseManager() {
      if (this.extraInfo.addManager) {
        this.xmlObj.baseinfo.manager = this.extraInfo.addManager;
        this.addManagerVisible = false;
      }
    },
    addManager() {
      if (!this.extraInfo.addManager) return
      let arr = this.xmlObj.baseinfo.manager.split(',')
      if (arr.indexOf(this.extraInfo.addManager) === -1) {
        this.xmlObj.baseinfo.manager += `,${this.extraInfo.addManager}`
        this.addManagerVisible = false
      } else {
        this.$Message.error('该客户经理已存在！')
      }
    },
    selectedCgr(cgrInfo) {
      this.cgrInfo = cgrInfo
      // 清除联系人信息
      this.xmlObj.cgrinfo.contact = "";
      this.xmlObj.cgrinfo.telephone = "";
      this.extraInfo.contactArr = [];
      this.xmlObj.cgrinfo.cgrname = "";
      this.xmlObj.cgrinfo.address = "";
      this.xmlObj.cgrinfo.industry = "";
      this.xmlObj.cgrinfo.cgrtype = "";
      this.xmlObj.cgrinfo.cgrid = "";
      
      this.selectCgrVisible = false;
      // this.xmlObj.baseinfo.apartment = cgrInfo.filiale;
      this.getArea(cgrInfo.filiale)
      let cgrData = this.xmlObj.cgrinfo;
      cgrData.cgrname = cgrInfo.purchase;
      cgrData.address = cgrInfo.contactAddress;
      cgrData.industry = cgrInfo.sysIndustry;
      cgrData.cgrtype = cgrInfo.purchaseSite;
      cgrData.cgrid = cgrInfo.id;
      // 联系方式处理.数据库数据可能有错
      try {
        let contact = cgrInfo.contactPersonOrWay;
        contact = contact.replace(/\'/g, '"');
        if (contact.indexOf('[') == -1) {
          contact = `[${contact}]`;
        }
        contact = JSON.parse(contact);
        this.extraInfo.contactArr = contact;
        this.init()
      } catch (err) {
        console.error(err);
      }
    },
    changeContact(contact) {
      let contactArr = this.extraInfo.contactArr;
      for (let i = 0; i < contactArr.length; i++) {
        if (contactArr[i]["联系人"] === contact) {
          this.xmlObj.cgrinfo.telephone = contactArr[i]["联系方式"];
          break;
        }
      }
    },
    async customerChange(val) {
      if (val === "否") {
        // 清除集团客户信息
        this.xmlObj.cgrinfo.customername = "";
        this.xmlObj.cgrinfo.branch = "";
      }
    },
    async branchChange(val) {
      // 清除分支信息
      this.xmlObj.cgrinfo.branch = "";
      let customerArr = this.extraInfo.customerArr;
      for (let i = 0; i < customerArr.length; i++) {
        if (customerArr[i].fullName === val) {
          let rep = await ajax.get('/api/services/app/BaseEntity/GetBranchCliens',
            {
              params: {
                CompanyId: customerArr[i].id
              }
            }
          );
          this.extraInfo.branchArr = rep.data.result.items;
          break;
        }
      }
    },
    areaChange (e) {
      this.xmlObj.baseinfo.area = e.toString()
    },
    localChange (e) {
      this.showLocalnum = e
    },
    finishEditContact(contact) {
      this.extraInfo.contactArr = contact;
      // 清除原选择联系人信息
      this.xmlObj.cgrinfo.contact = "";
      this.xmlObj.cgrinfo.telephone = "";
      this.contactVisible = false;
    },
    async businessChange(val) {
      let id = ''
      let type = ''
      this.extraInfo.businessScope.forEach((item, index) => {
        if (item.itemName == val) {
          id = this.extraInfo.businessScope[index].id
          type = this.extraInfo.businessScope[index].itemType
        }
      })
      // 清空项目性质
      this.xmlObj.category.projectnature = "";
      this.extraInfo.projectnatureArr = [];
      let rep = await this.getDataDict(type, 0, id)
      this.extraInfo.projectnatureArr = rep;
    },
    async natureChange(val) {
      // this.xmlObj.category.fundsprovid = ''
      if (this.hideImport) {
        this.extraInfo.fundsprovidArr = await this.getDataDict('资金类型(军工)')
      } else {
        this.extraInfo.fundsprovidArr = await this.getDataDict('资金类型')
      }
      if (val === '部队(涉密)' || val === '部队(非涉密)' || val === '军工(涉密)' || val === '军工(非涉密)') {
        this.xmlObj.category.cgmethod = ''
        this.xmlObj.category.importproduct = ''
      }
      this.extraInfo.cgmethodArr = await this.getDataDict('采购方式')
    },
    async fundChange (val) {
      if (val === '装备经费') {
        this.extraInfo.cgtypes = await this.getDataDict('采购类别(军工)')
      } else {
        this.extraInfo.cgtypes = await this.getDataDict('采购类别')
      }
    },
    resetCgType (e) {
      if (!e) {
        if (this.extraInfo.cgtypes.indexOf(this.xmlObj.category.cgtype) === -1) this.xmlObj.category.cgtype = ''
      }
    },
    // 获取数据集数据
    async getDataDict(type = '', ip = 0, id) {//ip控制是否只查询一级数据
      if (!type) {
        return []
      }
      let para = {}
      if (ip) {
        para = {
          filter: `itemType=="${type}"&&itemParent==""`
        }
      } else {
        para = {
          filter: `itemType=="${type}"`
        }
        if ((type === '采购方式' || type === '资金类型') && this.hideImport) {
          para.filter += `and describe == "军工"`
        }
      }
      if (id) {
        para = {
          filter: `itemType=="${type}"&&itemParent=="${id}"`
        }
      }
      let rep = await ajax.get(requestUrls.AbpDataDict.GetList, {
        params: para
      })
      if (rep.data.success) {
        return rep.data.result.items
      }
      return []
    },
    chooseServiceFee() {
      this.serviceFeeVisible = true
      this.serviceData = {
        cgtype: this.xmlObj.category.cgtype,
        amount: this.xmlObj.budget.budgetamount
      }
    },
    confirmServiceFee() {
      let feeResult = this.$refs.service.getResult();
      this.xmlObj.budget.servicetype = feeResult.feeType;
      this.xmlObj.budget.expectcharge = feeResult.fee;
      this.xmlObj.budget.servicediscount = ''
      if (feeResult.feeType === '折扣') {
        this.xmlObj.budget.servicediscount = feeResult.discount
      }
      this.serviceFeeVisible = false;
    },
    async buildWorkNum() {
      this.spinShow("正在生成编号，请稍候..");
      let childcompanyNo = ''
      for (let i = 0; i < this.extraInfo.childCompanies.length; i++) {
        let company = this.extraInfo.childCompanies[i]
        if (this.xmlObj.baseinfo.childcompany === company.cName) {
          childcompanyNo = company.companyAttr
          break
        }
      }
      try {
        let rep = await ajax.get(requestUrls.ClProjectDb.GetProjectNumber, {
          params: {
            company: this.xmlObj.baseinfo.apartment,
            projectAttr: this.xmlObj.category.projectnature,
            capitalSource: this.xmlObj.category.fundsprovid,
            companyAttr: childcompanyNo,
            isNew: true
          }
        })
        this.$Spin.hide()
        if (rep.data.success) {
          this.xmlObj.baseinfo.projectabbr = rep.data.result.numShor
          this.xmlObj.baseinfo.projectnumfull = rep.data.result.num
          if (this.xmlObj.category.separation === '是') {
            this.xmlObj.baseinfo.projectabbr = rep.data.result.numShor + 'P'
            this.xmlObj.baseinfo.projectnumfull = rep.data.result.num + 'P'
          }
          this.$Message.success("编号生成成功")
        } else {
          this.$Message.error("编号生成失败，请重新尝试")
        }

      } catch (err) {
        console.error(err);
        this.$Spin.hide();
        this.$Message.error("编号生成失败，请重新尝试");
      }
    },
    preventClick(type) {
      if (!this.xmlObj.baseinfo.projectnumfull) {
        this.$Message.error('请先生成项目编号')
        return
      }
      this.commissionFileType = type
      this.commissionModalChoose = true
    },
    commissionConfirm() {
      if (this.commissionFileType === '' || this.commissionType === '') {
        this.$Message.info('请选择类型')
        return
      }
      this.$Spin.show()
      let xmlObj = this.xmlObj
      if (this.commissionFileType == 'fill') {
        // this.projectArea = xmlObj.baseinfo.area.split(',')
        this.projectData = {
          purchaserId: xmlObj.cgrinfo.cgrid,  //  采购人id
          district: xmlObj.baseinfo.apartment,    // 部门
          newProjectTime: xmlObj.baseinfo.protime,  // 立项时间
          argument: xmlObj.category.argument,    // 是否有论证
          projectShort: xmlObj.baseinfo.projectabbr,  // 项目简称
          projectFull: xmlObj.baseinfo.projectnumfull,  // 项目编号全称
          projectName: xmlObj.baseinfo.projectname,  // 项目名称
          purchaserName: xmlObj.cgrinfo.cgrname,  // 采购人名称
          buyerModes: xmlObj.category.cgmethod,  // 采购方式
          sendOrders: xmlObj.category.finance,  // 是否财委派单功能
          capitalSource: xmlObj.category.fundsprovid,  // 资金来源
          area: xmlObj.baseinfo.area,  // 地区
          bidPlatform: xmlObj.category.platform,  // 招标平台
          buyerNature: xmlObj.category.cgtype,  //  采购性质
          clientSys: xmlObj.cgrinfo.industry,  // 客户系统类别
          projectState: xmlObj.baseinfo.prostatus,  // 项目状态
          am: xmlObj.baseinfo.manager,  // 客户经理
          aid: xmlObj.baseinfo.proassistant,  // 项目助理
          center: xmlObj.baseinfo.center,  // 中心
          pAddress: xmlObj.cgrinfo.address,  // 采购人联系地址
          pTel: xmlObj.cgrinfo.telephone,  // 采购人联系方式
          pContacts: xmlObj.cgrinfo.contact,  // 采购联系人
          pAttr: xmlObj.cgrinfo.cgrtype,  // 采购人属性
          purchaseContent: xmlObj.category.cgcontent,  // 采购内容
          import: xmlObj.category.importproduct,  // 是否采购进口产品
          projectProperty: xmlObj.category.projectnature,  // 项目性质
          localNumber: xmlObj.baseinfo.localnum,  // 当地编号
          separation: xmlObj.category.separation,  // 是否评定分离
          intermediary: xmlObj.budget.intermediary,  //是否有居间服务费
          chargingObjects: xmlObj.budget.chargingObjects,  //收费对象
          businessType: xmlObj.category.business,  // 业务分类
          groupCount: xmlObj.category.package,  // 包组数量
          purchaseBudget: xmlObj.budget.budgetamount,  // 采购预算
          qualifyPredict: xmlObj.budget.eligibility,  // 资格标预计收入
          servicePredict: xmlObj.budget.expectcharge,  // 预计服务费
          dataSource: xmlObj.baseinfo.proorigin,  // 数据来源
          companyName: xmlObj.baseinfo.childcompany,  // 公司属性
          comment: xmlObj.baseinfo.comment,  //  备注
          specialCustomer: xmlObj.cgrinfo.customername,  // 特殊客户(集团客户！)
          branchName: xmlObj.cgrinfo.branch,  // 分支机构
          serviceFeeType: xmlObj.budget.servicetype,  // 服务费类型
          discount: xmlObj.budget.servicediscount,  // 折扣
          receiveTime: new Date()  // 文件接收时间
        }
        switch (this.projectData.projectProperty){
          case '政府采购':
          case '企业采购':
          case '三大主体':
          case '国际标':
          case '军工(涉密)':
          case '军工(非涉密)':
          case '部队(涉密)':
          case '部队(非涉密)':
            let property = this.projectData.projectProperty
            if ((property == '军工(涉密)' || property == '军工(非涉密)' || property == '部队(涉密)' || property == '部队(非涉密)') && this.commissionType == 'standard') {
              this.$Modal.info({
                title: '提示',
                content: '暂无委托协议版本下载'
              })
              return
            }
            // 获取委托协议数据
            ajax.get('https://www.choicelink.cn:8444/cailian/GetTrustAgreementList',{
              params:{
                filter: `projectNum=="${this.projectData.projectFull}"`
              }
            }).then(res => {
              this.$Spin.hide()
              this.commissionModalChoose = false
              this.proxyVisible = true
              if (res.data.result.items.length != 0) {
                this.argumentData = res.data.result.items[0]
              } else {
                this.argumentData = {}
              }
            })
            break
          default: 
            this.$Modal.info({
              title: '提示',
              content: '暂无委托协议版本下载'
            });
        }
      }
      if (this.commissionFileType == 'download') {
        this.proxyUrl = ''
        if (this.commissionFileType === 'fill' && this.commissionType === 'standard') {
          this.proxyUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian/委托协议/go.cpt&op=write&projectName=${xmlObj.baseinfo.projectname}&projectNum=${xmlObj.baseinfo.projectnumfull}&cgfs=${xmlObj.category.cgmethod}&xmxz=${xmlObj.category.projectnature}&zbpt=${xmlObj.category.platform}&xmlb=${xmlObj.category.cgtype}`
        }
        if (this.commissionFileType === 'download' && this.commissionType === 'standard') {
          this.proxyUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B59d4%5D%5B6258%5D%5B534f%5D%5B8bae%5D%2F%5B59d4%5D%5B6258%5D%5B534f%5D%5B8bae%5D_go.cpt&projectName=${xmlObj.baseinfo.projectname}&projectNum=${xmlObj.baseinfo.projectnumfull}&cgfs=${xmlObj.category.cgmethod}&projectBudget=${xmlObj.budget.budgetamount}&cgr=${xmlObj.cgrinfo.cgrname}&xmxz=${xmlObj.category.projectnature}&zbpt=${xmlObj.category.platform}&xmlb=${xmlObj.category.cgtype}&cgnr=${xmlObj.category.cgcontent}&childcompany=${xmlObj.baseinfo.childcompany}`
        }
        if (this.commissionFileType === 'download' && this.commissionType === 'staticStandard') {
          this.proxyUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian/委托协议/InitialVersion/委托协议_go.cpt&projectName=${xmlObj.baseinfo.projectname}&projectNum=${xmlObj.baseinfo.projectnumfull}&cgfs=${xmlObj.category.cgmethod}&projectBudget=${xmlObj.budget.budgetamount}&cgr=${xmlObj.cgrinfo.cgrname}&xmxz=${xmlObj.category.projectnature}&zbpt=${xmlObj.category.platform}&xmlb=${xmlObj.category.cgtype}&cgnr=${xmlObj.category.cgcontent}&childcompany=${xmlObj.baseinfo.childcompany}`
        }
        if (this.commissionFileType === 'fill' && this.commissionType === 'armyYear') {
          this.proxyUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B59d4%5D%5B6258%5D%5B534f%5D%5B8bae%5D%2FMain_%5B519b%5D%5B5de5%5D%5B975e%5D%5B6d89%5D%5B5bc6%5D%5B5e74%5D%5B5ea6%5D.cpt&op=write&projectName=${xmlObj.baseinfo.projectname}&projectNum=${xmlObj.baseinfo.projectnumfull}&cgfs=${xmlObj.category.cgmethod}&xmxz=${xmlObj.category.projectnature}&zbpt=${xmlObj.category.platform}&xmlb=${xmlObj.category.cgtype}`
        }
        if (this.commissionFileType === 'download' && this.commissionType === 'armyYear') {
          this.proxyUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B59d4%5D%5B6258%5D%5B534f%5D%5B8bae%5D%2F%5B59d4%5D%5B6258%5D%5B534f%5D%5B8bae%5D_%5B519b%5D%5B5de5%5D%5B975e%5D%5B6d89%5D%5B5bc6%5D%5B5e74%5D%5B5ea6%5D.cpt&projectName=${xmlObj.baseinfo.projectname}&projectNum=${xmlObj.baseinfo.projectnumfull}&cgfs=${xmlObj.category.cgmethod}&projectBudget=${xmlObj.budget.budgetamount}&cgr=${xmlObj.cgrinfo.cgrname}&xmxz=${xmlObj.category.projectnature}&zbpt=${xmlObj.category.platform}&xmlb=${xmlObj.category.cgtype}&cgnr=${xmlObj.category.cgcontent}&childcompany=${xmlObj.baseinfo.childcompany}`
        }
        if (this.commissionFileType === 'download' && this.commissionType === 'staticArmyYear') {
          this.proxyUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian/委托协议/InitialVersion/委托协议_军工非涉密年度.cpt&projectName=${xmlObj.baseinfo.projectname}&projectNum=${xmlObj.baseinfo.projectnumfull}&cgfs=${xmlObj.category.cgmethod}&projectBudget=${xmlObj.budget.budgetamount}&cgr=${xmlObj.cgrinfo.cgrname}&xmxz=${xmlObj.category.projectnature}&zbpt=${xmlObj.category.platform}&xmlb=${xmlObj.category.cgtype}&cgnr=${xmlObj.category.cgcontent}&childcompany=${xmlObj.baseinfo.childcompany}`
        }
        if (this.commissionFileType === 'fill' && this.commissionType === 'armySingle') {
          this.proxyUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B59d4%5D%5B6258%5D%5B534f%5D%5B8bae%5D%2FMain_%5B519b%5D%5B5de5%5D%5B975e%5D%5B6d89%5D%5B5bc6%5D.cpt&op=write&projectName=${xmlObj.baseinfo.projectname}&projectNum=${xmlObj.baseinfo.projectnumfull}&cgfs=${xmlObj.category.cgmethod}&xmxz=${xmlObj.category.projectnature}&zbpt=${xmlObj.category.platform}&xmlb=${xmlObj.category.cgtype}`
        }
        if (this.commissionFileType === 'download' && this.commissionType === 'armySingle') {
          this.proxyUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B59d4%5D%5B6258%5D%5B534f%5D%5B8bae%5D%2F%5B59d4%5D%5B6258%5D%5B534f%5D%5B8bae%5D_%5B519b%5D%5B5de5%5D%5B975e%5D%5B6d89%5D%5B5bc6%5D.cpt&projectName=${xmlObj.baseinfo.projectname}&projectNum=${xmlObj.baseinfo.projectnumfull}&cgfs=${xmlObj.category.cgmethod}&projectBudget=${xmlObj.budget.budgetamount}&cgr=${xmlObj.cgrinfo.cgrname}&xmxz=${xmlObj.category.projectnature}&zbpt=${xmlObj.category.platform}&xmlb=${xmlObj.category.cgtype}&cgnr=${xmlObj.category.cgcontent}&childcompany=${xmlObj.baseinfo.childcompany}`
        }
        if (this.commissionFileType === 'download' && this.commissionType === 'staticArmySingle') {
          this.proxyUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian/委托协议/InitialVersion/委托协议_军工非涉密.cpt&projectName=${xmlObj.baseinfo.projectname}&projectNum=${xmlObj.baseinfo.projectnumfull}&cgfs=${xmlObj.category.cgmethod}&projectBudget=${xmlObj.budget.budgetamount}&cgr=${xmlObj.cgrinfo.cgrname}&xmxz=${xmlObj.category.projectnature}&zbpt=${xmlObj.category.platform}&xmlb=${xmlObj.category.cgtype}&cgnr=${xmlObj.category.cgcontent}&childcompany=${xmlObj.baseinfo.childcompany}`
        }
        this.$Spin.hide()
        this.commissionModalChoose = false
        this.proxyVisible = true
      }
    },
    // 加载过程
    spinShow(text) {
      this.$Spin.show({
        render: h => {
          return h("div", [
            h("Icon", {
              class: "demo-spin-icon-load",
              props: {
                type: "ios-loading",
                size: 18
              }
            }),
            h("div", text)
          ]);
        }
      });
    },
    async saveXml(status) {
      this.spinShow("正在保存数据，请稍候");
      // 不能修改由父组件传入的uid，用newUid记录新创建的xmlid
      if (!this.uid && !this.newUid) {
        // 没有父组件传的uid及新建的uid
        // xml配置ID，1为立项
        let configId = 2;
        try {
          let creator = this.currentObj.creator ? this.currentObj.creator : this.userObj.name
          let rep = await ajax.post('/api/services/app/CLUniForm/CreateOrUpdate', {
            clUniForm: {
              creator: creator,
              contentJson: JSON.stringify(this.xmlObj),
              configId: 2,
              creatime: this.currentObj.creatime ? this.currentObj.creatime : formatDate(),
              updatetime: formatDate(),
              state: 0,
              title: this.xmlObj.baseinfo.projectname
            }
          })
          if (rep.data.success) {
            this.newUid = rep.data.result.id
            this.$Message.success("保存成功")
            this.$emit('init')
          } else {
            this.$Message.error("保存失败")
          }
          this.$Spin.hide();
          return true;
        } catch (err) {
          console.error(err);
          this.$Message.error("保存失败");
          this.$Spin.hide();
          return false;
        }
      } else {
        // 已有xml数据修改
        let uid = this.newUid;
        if (this.uid) uid = this.uid
        try {
          let rep = await ajax.post('/api/services/app/CLUniForm/CreateOrUpdate', {
            clUniForm: {
              id: uid,
              creator: this.currentObj.creator ? this.currentObj.creator : this.userObj.name,
              contentJson: JSON.stringify(this.xmlObj),
              configId: 2,
              updatetime: formatDate(),
              creatime: this.currentObj.creatime ? this.currentObj.creatime : formatDate(),
              title: this.xmlObj.baseinfo.projectname,
              state: status ? status : this.currentObj.state || 0
            }
          })
          let message = status === 2 ? '保存' : status === 1 ? '流程发起' : '保存'
          if (rep.data.success) {
            this.$Message.success(`${message}成功`)
            this.$emit('init')
          } else {
            this.$Message.error(`${message}失败`)
          }
          this.$Spin.hide();
          return true;
        } catch (err) {
          console.error(err);
          this.$Message.error(`${message}失败`);
          this.$Spin.hide();
          return false;
        }
      }
    },
    // 更新数据
    async refreshXmlObj(xmlObj) {
      // 复制数据
      if (xmlObj.category.fundsprovid && !xmlObj.category.importproduct) {
        xmlObj.category.importproduct = '否'
      }
      this.$set(this.xmlObj, "baseinfo", xmlObj.baseinfo)
      this.$set(this.xmlObj, "cgrinfo", xmlObj.cgrinfo)
      this.$set(this.xmlObj, "category", xmlObj.category)
      this.$set(this.xmlObj, "budget", xmlObj.budget)
      this.$set(this.xmlObj, "workflow", xmlObj.workflow)
      this.projectArea = xmlObj.baseinfo.area.split(',')
      // 防止采购人联系方式报错
      if (typeof (this.xmlObj.cgrinfo.telephone) == 'object') this.xmlObj.cgrinfo.telephone = ''
      // 验证第一页数据（防红色报错）
      setTimeout(() => {
        this.$refs.proForm.validate()
      }, 0)
      // 采购联系人
      if (this.xmlObj.cgrinfo.contact) {
        this.extraInfo.contactArr = []
        this.extraInfo.contactArr.push({
          联系人: this.xmlObj.cgrinfo.contact,
          联系方式: this.xmlObj.cgrinfo.telephone
        })
      }
      // 采购联系人数据
      if (this.xmlObj.cgrinfo.branch) {
        let branch = this.xmlObj.cgrinfo.branch;
        this.branchChange(this.xmlObj.cgrinfo.customername);
        this.xmlObj.cgrinfo.branch = branch;
      }
      this.init()
    },
    // 项目重招数据导入
    importProject(projectData) {
      // 为什么写这句？？？
      for (let key in projectData.cgrinfo) {
        if (projectData.cgrinfo[key] === "") {
          projectData.cgrinfo[key] = ""
        }
      }
      // 刷新数据
      this.refreshXmlObj(projectData)
      // 重招工作流名称没有，补充
      this.xmlObj.workflow.title = projectData.baseinfo.projectname
      this.againProjectVisible = false
    },
    cancelAgainProject() {
      this.againProjectVisible = false
      this.$emit('cancelAgain')
    },
    async downloadCustomerFile() {
      if (!this.xmlObj.baseinfo.customerFileId || !this.xmlObj.baseinfo.customerFileName) {
        this.$Message.error('无上传文件')
        return
      }
      // window.open(`http://oa.chinapsp.cn:8088/FileServer/CaiLianFile/down2?fileid=${this.xmlObj.baseinfo.customerFileId}&filename=${this.xmlObj.baseinfo.customerFileName}`)
      // const blobUrl = await localFile.downLoadBlob(this.xmlObj.baseinfo.customerFileId)
      // localFile.currentLoad(blobUrl, this.xmlObj.baseinfo.customerFileName)
      localFile.directLoadFile(this.xmlObj.baseinfo.customerFileId)
    },
    async downloadProxyFile() {
      if (!this.xmlObj.baseinfo.proxyFileId || !this.xmlObj.baseinfo.proxyFileName) {
        this.$Message.error('无上传文件')
        return
      }
      // window.open(`http://oa.chinapsp.cn:8088/FileServer/CaiLianFile/down2?fileid=${this.xmlObj.baseinfo.proxyFileId}&filename=${this.xmlObj.baseinfo.proxyFileName}`)
      // const blobUrl = await localFile.downLoadBlob(this.xmlObj.baseinfo.proxyFileId)
      // localFile.currentLoad(blobUrl, this.xmlObj.baseinfo.proxyFileName)
      localFile.directLoadFile(this.xmlObj.baseinfo.proxyFileId)
    },
    save() {
      this.$refs.agreement.save()
    }
  },
  watch: {
    userObj(val, oldVal) {
      this.init()
      if (!!val.name) {
        this.xmlObj.baseinfo.manager = val.name
      }
    },
    "xmlObj.budget.budgetamount"(val, oldVal) {
      if (oldVal !== "") {
        this.xmlObj.budget.servicetype = "";
        this.xmlObj.budget.expectcharge = "";
        this.xmlObj.baseinfo.servicediscount = ''
      }
    },
    againProject(val) {
      this.againProjectVisible = val
    },
    // 当父组件有传入uid，初始化数据或重置数据
    async uid(val, oldVal) {
      this.stepCurrent = 0;
      if (!!val) {
        const x2Json = new x2js()
        ajax.get(`/api/services/app/CLUniForm/GetById?id=${val}`).then(async(res) => {
          let xmlJson = x2Json.xml2js(res.data.result.content)
          this.refreshXmlObj(xmlJson.root)
          this.currentObj = res.data.result
        })
      }
    },
    visibleChange(val) {
      // 外部使用完毕清空数据
      if (!val) {
        // 清空项目经理信息
        this.addManagerVisible = false
        this.extraInfo.addManager = ''
        // 清空newUid防止覆盖
        this.newUid = ''
        // 流程步骤
        this.stepCurrent = 0
        // 清空联系人数组
        this.extraInfo.contactArr = []
        // 项目信息
        this.xmlObj = {
          // error: {
          //   errorholder: "err",
          //   errorholder1: "err"
          // },
          baseinfo: {
            apartment: "",
            area: "",
            projectabbr: "",
            projectnumfull: "",
            localnum: "",
            projectname: "",
            manager: "",
            protime: "",
            prostatus: "等待用户需求",
            proassistant: "",
            proorigin: "内网立项",
            customerFileName: '',
            customerFileId: '',
            proxyFileName: '',
            proxyFileId: '',
            childcompany: '',
            comment: '',
            center: ''
          },
          category: {
            business: "",
            platform: "",
            projectnature: "",
            cgtype: "",
            fundsprovid: "",
            cgmethod: "",
            importproduct: "",
            argument: "",
            package: '',
            cgcontent: "",
            separation: "",
            finance: ""
          },
          cgrinfo: {
            customername: "",
            branch: "",
            cgrname: "",
            cgrid: "",
            address: "",
            telephone: "",
            contact: "",
            cgrtype: "",
            industry: "",
            iscustomer: "",
            customerSource: ""
          },
          budget: {
            eligibility: "",
            budgetamount: "",
            servicetype: "",
            servicediscount: '',
            expectcharge: "",
            // servicecharge: "",
            intermediary: "",
            chargingObjects: ''
          },
          workflow: {
            title: ""
          }
        }
      }
    }
  }
};
</script>

<style lang="less">
.step-form {
  margin-top: 15px;
}
.step-btn {
  text-align: right;
  border-bottom: 1px solid #e9eaec;
  height: 40px;
}
.cgrclass {
  z-index: 1500;
}
.set-project {
  .ivu-input[disabled],
  fieldset[disabled] .ivu-input {
    color: #000;
  }
}
.ivu-select-disabled .ivu-select-selection {
  color: black;
}
.proxy-modal {
  .ivu-modal {
    top: 20px;
  }
}
</style>
